import * as React from "react";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";

const MenuRow = (props) => {
  const module = props.module;
  const location = useLocation();
  const [path, setPath] = React.useState(location.pathname);
  const modulePath = module.routeProps.path + location.search;
  const LabelComponent = module.getLabelComponent;

  React.useEffect(() => {
    setPath(location.pathname);
  }, [location]);

  return (
    <MenuItem
      key={module.label}
      component={NavLink}
      to={modulePath}
      sx={{ pt: 1 }}
      path={path}
    >
      <ListItemText
        primary={LabelComponent ? <LabelComponent /> : module.label}
      />
    </MenuItem>
  );
};

export default MenuRow;
